import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    border-radius: 2rem 2rem 0 0;

    width: 100vw;
    max-width: 565px;
    background-color: ${theme.palette.neutral[50]};
    box-shadow: ${theme.layout.shadows.popup};

    overflow-y: auto;
    max-height: 100vh;

    form {
      display: flex;
      flex-direction: column;
      row-gap: 1rem;
      padding: ${theme.layout.spacing(0, 3, 3)};

      p {
        color: ${theme.palette.text.main};
        font-size: ${theme.typography.sizes.body2};
      }

      small {
        color: ${theme.palette.text.light};
        font-size: ${theme.typography.sizes.caption};
      }
    }

    @media (min-width: ${theme.layout.breakpoints.md}) {
      border-radius: 2rem;
    }
  `}
`;
